// extracted by mini-css-extract-plugin
export default {"showcase":"Showcase_showcase__vAlO6","leftContainer":"Showcase_leftContainer__Upe9b","rightContainer":"Showcase_rightContainer__5zbRW"};